<template>
    <div class="slideshow">

        <div  class="slideshow__slide"
        v-for="(slide,index) in slides"
           :key="slide.img"
           :style="index == slideShowIndex ? 'display:block;': 'display:none;'"
        >
            <a :href="slide.href">
                <picture>
                    <source type="image/webp" class="slideshow__img" :srcset="slide.img1" :title="slide.title" :alt="slide.alt">
                    <img  :src="slide.img" class="slideshow__img" :title="slide.title" :alt="slide.alt">
                </picture>
            </a>
        </div>

        <div class="d-none d-lg-block">
        <span @click="move(+1)" class="slideshow__prev" style="left: 95%; cursor: pointer;">&#10095;</span>
        <span @click="move(-1)" class="slideshow__next" style="right: 95%; cursor: pointer;">&#10094;</span>
        </div>
        <div class="slideshow__items">
            <div class="slideshow__item" v-for="(slide, index) in slides" :key="slide.img">
                <div class="slideshow__item-inner" :style="index === slideShowIndex ? `width: ${progWith}%` : ''"></div>
            </div>

        </div>

    </div>
<br><br><br>

</template>
<script>

    export default {
        name: "SlideOne",

        data: () =>({
            slides: [
                { img: ('../images/هواکش-ژنیران.jpg'),img1: ('../images/هواکش-ژنیران.webp'),href:'product/هواکش-ایلکا-هفت-پر-فلزی-ژنیران',title:'هواکش-صنعتی-ژنیران',alt:'هواکش-ژنیران'},
                { img:  ('../images/هواکش-دمنده.jpg'),img1: ('../images/هواکش-دمنده.webp'),href:'product/هواکش-صنعتی-سبک-دمنده',title:'هواکش-صنعتی-دمنده',alt:'هواکش-دمنده' },
            ],
            slideShowIndex:0,
            slideInterwall: null,
            progWith: 0

        }),
        methods:{
            move(n){
                  if(this.slides.length <= this.slideShowIndex + n){
                      this.slideShowIndex=0;
                  }else if(this.slideShowIndex + n < 0)
                  {
                      this.slideShowIndex=(this.slides.length -1);
                  }else{
                      this.slideShowIndex += n;
                  }

            }
        },
        created(){
          this.slideInterwall=setInterval(() =>{
              if (this.progWith >= 100){
                  this.progWith=0;
                   this.move(1)
              }else{
                  this.progWith++;
              }
          },55)
        },
        destroyed(){
            clearInterval(this.slideInterwall)
        }


    };
</script>
